import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthCallback from "./pages/AuthCallback";
import Login from "./pages/Login";
import Landing from "./pages/Landing";
import AppLayout from "./components/AppLayout";
import Dashboard from "./pages/Dashboard";
import Inbox from "./pages/Inbox";
import Contacts from "./pages/Contacts";
import Leads from "./pages/Leads";
import AIAgent from "./pages/AIAgent";
import Knowledge from "./pages/Knowledge";
import AssetLibrary from "./pages/AssetLibrary";
import Broadcasts from "./pages/Broadcasts";
import Offers from "./pages/Offers";
import SavedReplies from "./pages/SavedReplies";
import Settings from "./pages/Settings";
import Admin from "./pages/Admin";
import Automations from "./pages/Automations";
import VoiceCalls from "./pages/VoiceCalls";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F0F2F5]">
        <div className="font-mono text-xs text-[#8696A0] animate-pulse">initializing muviarts.online…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Detect session_id synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <Protected>
            <AppLayout />
          </Protected>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/ai-agent" element={<AIAgent />} />
        <Route path="/knowledge" element={<Knowledge />} />
        <Route path="/assets" element={<AssetLibrary />} />
        <Route path="/broadcasts" element={<Broadcasts />} />
        <Route path="/offers" element={<Offers />} />
        <Route path="/saved-replies" element={<SavedReplies />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/:tab" element={<Settings />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/:section" element={<Admin />} />
        <Route path="/voice" element={<VoiceCalls />} />
        <Route path="/voice/:tab" element={<VoiceCalls />} />
        <Route path="/automations" element={<Automations />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster theme="light" position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
